// extracted by mini-css-extract-plugin
export default {"AccordianTitle":"timeSlots_AccordianTitle__AF2aU","mainHeading":"timeSlots_mainHeading__oCuor"};